import React from 'react';
import { motion } from 'framer-motion';
export function AboutNicole() {
  return <section className="py-24 bg-white" data-id="element-41">
      <div className="max-w-6xl mx-auto px-6" data-id="element-42">
        <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20" data-id="element-43">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full md:w-1/2" data-id="element-44">
            <div className="relative" data-id="element-45">
              <div className="absolute inset-0 bg-rosegold/20 rounded-3xl transform translate-x-4 translate-y-4" data-id="element-46"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kpVrCPSWuXAnViG1Cefqkt/180CEA11-01BE-46F5-A413-75D2EEDF1DE4.jpg" alt="Nicole Cabello - Impulsadora de Mujeres" className="relative z-10 w-full h-auto rounded-3xl object-cover shadow-xl" data-id="element-47" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full md:w-1/2" data-id="element-48">
            <p className="text-rosegold font-medium mb-6 uppercase tracking-wider text-sm" data-id="element-49">
              Impulsadora de Mujeres
            </p>

            <div className="space-y-4 text-lg text-taupe leading-relaxed" data-id="element-50">
              <p data-id="element-51">
                Durante años viví desconectada de mí misma, persiguiendo metas
                que no eran mías y operando desde el agotamiento constante.
                Creía que para ser exitosa tenía que sacrificar mi paz mental.
              </p>
              <p data-id="element-52">
                Hasta que entendí que la verdadera transformación no viene de
                hacer más, sino de <strong data-id="element-53">ser más coherente</strong> con quien
                realmente eres.
              </p>
              <p data-id="element-54">
                He creado el Método Coherencia Femenina para compartir contigo
                las herramientas exactas que me permitieron regular mi energía,
                reprogramar mi identidad y construir una vida que se siente bien
                por dentro, no solo que se ve bien por fuera.
              </p>
            </div>

            <div className="mt-10" data-id="element-55">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Stylized_signature_sample.svg/1200px-Stylized_signature_sample.svg.png" alt="Firma Nicole" className="h-12 opacity-40 filter sepia hue-rotate-[-50deg] saturate-200" data-id="element-56" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}